import React, { useCallback, useEffect, useMemo, useState } from "react";
import CustomPopup from "../../../Pages/Inbox/Popups/CustomPopup.js";
import { homeColors } from "helpers/getBackgroundColor.js";
import Image from "components/Elements/Image/Image.tsx";
import Icon from "components/Elements/Icon/Icon.tsx";

const SingleContact = ({ contactData, handleClick }) => {
  const email = contactData.contact_list_email;
  const name = contactData.contact_list_full_name;

  const randColor = useMemo(() => {
    return homeColors[Math.floor(Math.random() * homeColors.length)];
  }, []);

  return (
    <button
      className="contact-item"
      onClick={(e) => {
        e.preventDefault();
        handleClick(email);
      }}
      key={email}
    >
      <div
        className="contact-img"
        style={{
          backgroundColor: randColor,
        }}
      >
        {contactData.contact_list_favorite ? (
          <div className="favorite-contact">
            <Icon name={"star-solid"} orange />
          </div>
        ) : null}
        {contactData.contact_list_image ? (
          <Image
            src={contactData.contact_list_image}
            className="contact-avatar"
          />
        ) : (
          email.charAt(0)
        )}
      </div>
      <div className="name-section">
        <span>{email}</span>
        <span>{name || email}</span>
      </div>
    </button>
  );
};

export const AutoCompleteContacts = ({
  value = "",
  open,
  handleClick,
  list,
}) => {
  const [filteredList, setFilteredList] = useState([]);
  const [openList, setOpenList] = useState(false);

  useEffect(() => {
    if (list) {
      if (open && value.length === 0) {
        setFilteredList(list);
      } else if (value.length >= 1) {
        setFilteredList(
          list.filter((contact) => {
            const noKeySensitiveValue = value.toLowerCase();
            const userEmail = contact.contact_list_email?.toLowerCase();
            const userName = contact.contact_list_full_name?.toLowerCase();
            return (
              userEmail?.includes(noKeySensitiveValue) ||
              userName?.includes(noKeySensitiveValue)
            );
          })
        );
      } else {
        setOpenList(false);
        setTimeout(() => {
          setFilteredList([]);
        }, 300);
      }
    }
  }, [value, open, list]);

  useEffect(() => {
    if (filteredList.length === 0) {
      setOpenList(false);
    } else {
      setOpenList(true);
    }
  }, [filteredList]);

  return (
    <div className="relative-element">
      <CustomPopup topPosition={0} showState={openList}>
        <div className="contacts-list">
          {filteredList.map((contact) => (
            <SingleContact
              contactData={contact}
              handleClick={handleClick}
              key={contact.contact_list_id}
            />
          ))}
        </div>
      </CustomPopup>
    </div>
  );
};
